import { FILE_PATH_URI, handleDownload } from "../../../../../utils/helper";
import { Avatar, Box, ListItemText, Paper, styled } from "@mui/material";
import { useSelector } from "react-redux";
import moment from "moment";
import Icons from "../../../../../assets/js/Icons";

const Image = styled("img")();
function Postview({ isSender = true, message }) {
  const { chat } = useSelector((state) => state.socketSlice);
  const { member, specialist } = useSelector((state) => state.authSlice);

  return (
    <Box
      sx={{
        gap: 1,
        display: "flex",
        flexDirection: isSender ? "row-reverse" : "row"
      }}
    >
      <Avatar
        sx={{ width: 30, height: 30 }}
        src={FILE_PATH_URI + (isSender ?
          (member?.image || specialist?.specialist?.image || specialist?.image)
          : chat?.user?.image)}
      />
      <Box sx={{ m: 0, p: 1, maxWidth: "60%", bgcolor: "white", borderRadius: "5px" }}>
        <Paper paperVariant="chatFilePostView" sx={{ justifyContent: isSender ? "end" : "start" }}>
          {message?.files?.map((element, i) => (
            element?.mimetype === "image" ?
              <Paper key={i} paperVariant="filePostViewA">
                <Image src={FILE_PATH_URI + element.path} alt="preview" />
                <Box role="button" onClick={() => handleDownload(FILE_PATH_URI + element?.path)}><Icons.CloudDownloadSolid /></Box>
              </Paper> :
              <Paper key={i} paperVariant="filePostViewA">
                <Icons.ForumAll />
                <span>{element?.filetype?.toUpperCase()}</span>
                <Box role="button" onClick={() => handleDownload(FILE_PATH_URI + element?.path)}><Icons.CloudDownloadSolid /></Box>
              </Paper>
          ))
          }
        </Paper>
        <ListItemText
          primary={message?.text}
          secondary={moment(message?.createdAt).format("DD-MM hh:mm A")}
          slotProps={{
            primary: { style: { fontSize: 15, lineHeight: 1.2 } },
            secondary: { style: { fontSize: 13, lineHeight: 1.2, marginTop: 5 } },
          }}
        />
      </Box>
    </Box>
  )
}

export default Postview